import { openModal } from '@core/components/ModalStack';
import { ProjectOverlayProps } from './ProjectOverlay';

export async function openProjectOverlay(props: ProjectOverlayProps) {
  const { ProjectOverlay } = await import('./ProjectOverlay');

  openModal(ProjectOverlay, props);
}
